"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrMaintenanceNotifications = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const config_1 = __importDefault(require("next/config"));
const react_1 = __importStar(require("react"));
const fdr_maintenance_notifications_utils_1 = require("./fdr-maintenance-notifications.utils");
const fdr_maintenance_notification_1 = require("./fdr-maintenance-notification");
const { publicRuntimeConfig } = (0, config_1.default)();
const NOTIFICATION_KEY_PREFIX = `${(_a = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.brand) === null || _a === void 0 ? void 0 : _a.toLowerCase()}_notification`;
const FdrMaintenanceNotifications = ({ notifications = [], solidBg = false, }) => {
    const [closedNotifications, setClosedNotifications] = (0, react_1.useState)([]);
    const now = new Date();
    function handleCloseNotification(notification) {
        if (notification.closable) {
            (0, fdr_maintenance_notifications_utils_1.setNotificationCookie)({
                id: notification.id || '',
                showIfClosed: notification.showIfClosed,
            });
            setClosedNotifications(prevState => [
                ...prevState,
                notification.id || '',
            ]);
        }
    }
    return (react_1.default.createElement("div", null, notifications.map(function renderNotification(notification, index) {
        const rawExpTime = js_cookie_1.default.get(`${NOTIFICATION_KEY_PREFIX}_${notification.id}`);
        const expTime = parseInt(rawExpTime || '0', 10);
        if (closedNotifications.includes(notification.id || ''))
            return null;
        if (rawExpTime === '0')
            return null;
        if (rawExpTime && expTime >= now.valueOf())
            return null;
        return (react_1.default.createElement(fdr_maintenance_notification_1.FdrMaintenanceNotificationWrapper, Object.assign({ key: notification.id || index, solidBg: solidBg, onClose: () => handleCloseNotification(notification) }, notification)));
    })));
};
exports.FdrMaintenanceNotifications = FdrMaintenanceNotifications;
//# sourceMappingURL=fdr-maintenance-notifications.js.map